import { useContext as o } from "react";
import { SelectorLayoutContext as t } from "./selectorLayout.js";
const m = () => o(t);
export {
  m as useSelectorLayout
};
//# sourceMappingURL=useSelectorLayout.js.map
